export enum AdStyle {
    top,
    middle,
    left,
    bottom,
    popup
}